module.exports = __webpack_public_path__ + "static/media/inventory_2_white_24dp.26b418ec.svg";